import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import LottieAnimation from '@base/LottieAnimation/LottieAnimation';
import { Fonts } from '@styles/index';
import { getAnimationPath } from '@utils/animationHelpers';

const Wrapper = styled.div`
  grid-column: 1 / 19;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: -10vh;
  height: ${({ $height }) => $height}px;
`;

const Title = styled(H4)`
  font-weight: ${Fonts.SEMIBOLD};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
`;

const AnimationContainer = styled(LottieAnimation)`
  width: 160px;
  height: 160px;
`;

const SettingUpPlanner = ({ height }) => {
  return (
    <Wrapper $height={height}>
      <AnimationContainer
        src={getAnimationPath('planner/settingUpLoader.json')}
      />
      <Title>Setting up your planner</Title>
    </Wrapper>
  );
};

export default SettingUpPlanner;
